import dayjs from 'dayjs';
import { TRADING_PROGRESS_STATUS_VARIABLES } from 'lib-tw-common';

export const tradingListFilterSchema = [
  {
    key: 'tradingId',
    labelKey: 'Label.Trading/Flow ID',
    type: 'text',
    props: {
      placeholder: 'Enter keyword',
      class: 'trading-flow',
      trim: true,
    },
  },
  {
    key: 'tradingName',
    labelKey: 'Label.Trading Name',
    type: 'text',
    showInChip: true, // rules: [{ required: true, message: '必須です', trigger: 'change' }],
    rules: [],
    props: { placeholder: 'Enter keyword', style: { width: '235px' } },
  },
  {
    key: 'ownerSectionIds',
    labelKey: 'Label.Owner',
    type: 'select',
    multiple: true,
    collapseTags: true,
    options: [],
    props: {
      class: 'section',
      popperClass: 'owner-section',
      placeholder: 'Select',
      clearable: true,
    },
  },
  {
    key: 'flowUpdateDatetime',
    labelKey: 'Label.Update Datetime',
    type: 'daterange',
    showInChip: true,
    rules: [],
    props: {
      type: 'datetimerange',
      format: 'yyyy-MM-dd HH:mm',
      clearable: false,
      valueFormat: 'yyyy-MM-dd HH:mm:ss',
      defaultTime: ['00:00:00', '23:59:59'],
      startPlaceholder: 'Start datetime',
      endPlaceholder: 'End datetime',
      popperClass: 'within-system-trading-list-days',
    },
  },
];
